import HomeScreen from './screens/HomeScreen'
import './App.css'

//fonts
import './fonts/JeremyMoore.otf'
import './fonts/JeremyMoore.ttf'
import './fonts/JeremyMoore.woff'
import './fonts/JeremyMoore.woff2'
import './fonts/InterTight.ttf'

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import ProfileScreen from './screens/ProfileScreen'
import { useSelector } from 'react-redux'
import { getUser } from './app/features/userSlice'
import EpisodeScreen from './screens/EpisodeScreen'
import RecoverPasswordScreen from './screens/RecoverPasswordScreen'
import EmailScreen from './screens/EmailScreen'
import SignInScreen from './screens/SignInScreen'
import SignUpScreen from './screens/SignUpScreen'
import PlanScreen from './screens/PlanScreen'
import UnpaidScreen from './screens/UnpaidScreen'
import SerieScreen from './screens/SerieScreen'
import DraftScreen from './screens/DraftScreen'
import SearchScreen from './screens/SearchScreen'
import { useEffect } from 'react'
import OneSignal from 'react-onesignal'
import CollectTaxIDScreen from './screens/CollectTaxIDScreen'
import ScheduleScreen from './screens/ScheduleScreen'
import MobileRedirect from './components/MobileRedirect'
import BlockedScreen from './screens/BlockedScreen'

function App() {
  const user = useSelector(getUser)

  useEffect(() => {
    OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
      notifyButton: {
        enable: false,
      },
      notificationClickHandlerAction: "navigate",
      autoRegister: true,
      autoResubscribe: true,
    });
  }, []);

  return (
    <div className="app">
      <BrowserRouter>
        <MobileRedirect />
        <Routes>
          <Route path="/" element={!user ? <EmailScreen /> : <HomeScreen />} />
          <Route path="/signin" element={<SignInScreen />} />
          <Route path="/signup" element={<SignUpScreen />} />
          <Route path="/plan" element={<PlanScreen />} />
          <Route path="/unpaid" element={!user ? <EmailScreen /> : <UnpaidScreen />} />
          <Route path="/collect-tax-id" element={!user ? <EmailScreen /> : <CollectTaxIDScreen />} />
          <Route path="/profile" element={!user ? <EmailScreen /> : <ProfileScreen />} />
          <Route path="/episodes/:id" element={!user ? <EmailScreen /> : <EpisodeScreen />} />
          <Route path="/series/:id" element={!user ? <EmailScreen /> : <SerieScreen />} />
          <Route path="/draft" element={<DraftScreen />} />
          <Route path="/recover-password" element={<RecoverPasswordScreen />} />
          <Route path="/recover-password/:token" element={<RecoverPasswordScreen />} />
          <Route path="/search/:title" element={!user ? <EmailScreen /> : <SearchScreen />} />
          <Route path="/schedule" element={!user ? <EmailScreen /> : <ScheduleScreen />} />
          <Route path="/blocked" element={<BlockedScreen />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
